__turbopack_context__.v({
  "className": "inter_b1095fd1-module__f9oXna__className",
  "variable": "inter_b1095fd1-module__f9oXna__variable",
});
